import React from 'react';
export const EarlyAccess = React.lazy(() => import('./EarlyAccess.jsx'));
